/** Dispatched when any API call proves the JWT is invalid (fetch or axios). */
export const AUTH_INVALID_SESSION_EVENT = 'auth:invalid-session';

/**
 * Clears persisted buyer auth. When notify is true, React AuthProvider should
 * clear in-memory user/token (see listener in AuthContext).
 */
export function clearStoredAuthSession({ notify = true } = {}) {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch {
    /* ignore */
  }
  if (notify) {
    try {
      window.dispatchEvent(new Event(AUTH_INVALID_SESSION_EVENT));
    } catch {
      /* ignore */
    }
  }
}

export function isAuthSessionRejected(status, body) {
  if (status === 401) return true;
  const msg = body && (body.error || body.message);
  return status === 403 && msg === 'Invalid or expired token';
}
